export const blastoiseEasterEgg = `
DON'T PASTE ANYTHING HERE, OR BLASTOISE WILL HUNT YOU!

⠀⠀⠀⠀⠀⣠⣴⣾⣶⣿⣿⣶⣶⣶⣿⡟⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀
⠀⠀⠀⣠⣼⣿⣿⣿⣋⣠⣿⣿⣿⣿⣿⡖⢶⣶⣤⣤⣀⣤⣶⣿⣷⡤⠶⢦⡀⠀
⠀⠀⣤⣾⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⡿⠀⠘⢿⣿⣿⣿⡿⢁⣾⡀⠀⠀⣷⠀
⠀⠀⠻⣿⠟⠛⠛⠻⠟⠛⠋⢹⣿⣿⣿⢣⡆⠀⠈⠛⠛⠋⠀⢻⣿⣿⣶⠟⣻⣦
⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢸⣿⣿⢇⣾⠃⠀⣠⣤⣴⣤⣤⣀⠉⠙⢁⣴⡿⠁
⠀⠀⠀⠀⠀⢠⠀⠀⠀⢰⣤⣿⣿⢋⣬⡄⢀⣾⣿⣿⣿⣿⣿⣿⣧⠀⢿⣿⠀⠀
⠀⠀⠀⠀⠀⣠⠻⠿⠿⠿⠿⣛⣵⣿⣿⣧⢸⣿⣿⣿⣿⣿⣿⣿⣿⣄⣼⣿⡇⠀
⠀⠀⠀⠀⣠⣿⡀⢸⣿⣿⣿⣿⣿⣿⣿⠿⠆⠻⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣷⠀
⢀⣀⣴⣾⣿⣿⡇⣬⣭⣭⣭⣭⣭⣶⣶⣿⣷⡄⢈⣻⣿⣿⣿⣿⣿⣿⣿⣿⣿⠀
⠰⢾⣿⣿⣿⣿⡇⣿⣿⣿⣿⣿⣿⣿⣿⣿⡟⢐⣛⡻⣿⣿⣿⣿⣿⣿⠻⣿⣿⠀
⠀⠁⠀⣠⣶⣿⣷⢸⣿⣿⣿⣿⣿⣿⣿⡿⠿⠛⠋⡵⠿⢿⣿⣿⣿⢟⣄⢹⡏⠀
⠀⠀⣰⣿⣿⣿⣿⣆⢲⣶⣶⣶⣶⣶⣶⣶⣿⢇⣷⣾⣿⡏⣟⣯⣶⣿⣿⡾⠀⠀
⠀⠀⣿⣿⣿⣿⣿⣿⣦⠹⣿⣿⣿⣿⣿⣿⣿⡜⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⡶⠋
⠀⠀⠘⣿⣿⣿⣿⣿⣿⣷⣬⠉⠿⣛⣻⣿⣯⣥⣹⣿⣿⣿⣿⣿⣿⣿⣿⣿⠀⠀
⠀⣠⣶⣿⣿⣿⣿⣿⣿⠿⠿⠦⠄⠀⠀⠉⠉⠉⠀⠹⣿⣿⣿⣿⣿⣿⣿⣿⠀⠀
⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠹⠿⠛⠿⣿⠟⠛⠛⠀⠀
`;
